import { render, staticRenderFns } from "./install-order-details.vue?vue&type=template&id=0a253a37&scoped=true&"
import script from "./install-order-details.vue?vue&type=script&lang=js&"
export * from "./install-order-details.vue?vue&type=script&lang=js&"
import style0 from "./install-order-details.vue?vue&type=style&index=0&id=0a253a37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a253a37",
  null
  
)

export default component.exports